module.exports = __webpack_public_path__ + "./zaou_7e832f945071eef50c43cd8d645021a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2017/zaou.png
// module id = 455
// module chunks = 0